<template>
<v-autocomplete
 v-model="person"
 hide-no-data
 hide-selected
 placeholder="Start typing to search..."
 :items="items"
 :loading="isLoading"
 :search-input.sync="search"
>
  <template v-if="extraItems" #append-item>
    <v-divider />
    <v-list-item>
      <v-list-item-title class="text-center">
        <em>{{ extraItems }} results not shown...</em>
      </v-list-item-title>
    </v-list-item>
  </template>
  <template #item="{ item }">
    <v-list-item-avatar>
      <v-img v-if="item.poster" :src="item.poster" />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </v-list-item-content>
  </template>
</v-autocomplete>
</template>

<script>
import { debounce } from "debounce"

export default {
  name: "PersonField",
  props: {
    value: String,
  },
  data() {
    return {
      isLoading: false,
      search: null,
      items: [],
      extraItems: 0,
    }
  },
  inject: ["httpClient"],
  created() {
    this.debouncedGetItems = debounce(this.getItems, 700)
  },
  computed: {
    person: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
  },
  methods: {
    async getItems() {
      const items = await this.httpClient.searchPersons({
        query: this.search
      })
      this.extraItems = items.has_next ? items.count - items.results.length : 0
      this.items = items.results.map(p => ({
        ...p,
        text: p.name,
        value: p.name,
      }))
      this.isLoading = false
    },
  },
  watch: {
    search(val) {
      if (this.isLoading || !val) return
      this.isLoading = true
      this.debouncedGetItems()
    },
  },
}
</script>
